/** @format */

//ローディング画面の表示非表示を切り替える
export const setIsLoading = (bool: boolean, dispatch: Function) => {
  dispatch({
    type: "set-context-data",
    payload: {
      isLoading: bool,
    },
  });
};
